import { render, staticRenderFns } from "./expressDelivery.vue?vue&type=template&id=67f805ae&scoped=true"
import script from "./expressDelivery.vue?vue&type=script&lang=js"
export * from "./expressDelivery.vue?vue&type=script&lang=js"
import style0 from "./expressDelivery.vue?vue&type=style&index=0&id=67f805ae&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67f805ae",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/jenkins/workspace/重构-快递前端-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('67f805ae')) {
      api.createRecord('67f805ae', component.options)
    } else {
      api.reload('67f805ae', component.options)
    }
    module.hot.accept("./expressDelivery.vue?vue&type=template&id=67f805ae&scoped=true", function () {
      api.rerender('67f805ae', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/invoiceCenter/nfseDataCheck/cmp/expressDelivery.vue"
export default component.exports